"use strict";

var _possibleConstructorReturn = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/possibleConstructorReturn");
var _getPrototypeOf = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/getPrototypeOf");
var _inherits = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/inherits");
var _objectSpread = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/objectSpread");
var _classCallCheck = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");
var _createClass = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createClass");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.InterRegionPaddingBlock = exports.ElidedBlock = exports.ContentBlock = exports.BaseBlock = exports.BlockSet = void 0;
var BlockSet = /*#__PURE__*/function () {
  function BlockSet() {
    var blocks = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
    _classCallCheck(this, BlockSet);
    this.blocks = blocks;
  }
  _createClass(BlockSet, [{
    key: "push",
    value: function push(block) {
      if (block instanceof ElidedBlock) {
        if (this.blocks.length) {
          var lastBlock = this.blocks[this.blocks.length - 1];
          if (lastBlock instanceof ElidedBlock) {
            lastBlock.push(block);
            return;
          }
        }
      }
      this.blocks.push(block);
    }
  }, {
    key: "getBlocks",
    value: function getBlocks() {
      return this.blocks;
    }
  }, {
    key: "getRegions",
    value: function getRegions() {
      return this.blocks.map(function (block) {
        return block.toRegion();
      });
    }
  }, {
    key: "map",
    value: function map(func, thisarg) {
      return this.blocks.map(func, thisarg);
    }
  }, {
    key: "forEach",
    value: function forEach(func, thisarg) {
      return this.blocks.forEach(func, thisarg);
    }
  }, {
    key: "length",
    get: function get() {
      return this.blocks.length;
    }
  }, {
    key: "totalWidthPx",
    get: function get() {
      return this.blocks.length ? this.blocks.map(function (blocks) {
        return blocks.widthPx;
      }).reduce(function (a, b) {
        return a + b;
      }) : 0;
    }
  }, {
    key: "totalWidthPxWithoutBorders",
    get: function get() {
      return this.blocks.length ? this.blocks.filter(function (block) {
        return block.variant !== 'boundary';
      }).map(function (blocks) {
        return blocks.widthPx;
      }).reduce(function (a, b) {
        return a + b;
      }) : 0;
    }
  }, {
    key: "offsetPx",
    get: function get() {
      return this.blocks.length ? this.blocks[0].offsetPx : 0;
    }
  }, {
    key: "contentBlocks",
    get: function get() {
      return this.blocks.filter(function (block) {
        return block instanceof ContentBlock;
      });
    }
  }, {
    key: "totalBp",
    get: function get() {
      return this.contentBlocks.map(function (block) {
        return block.end - block.start;
      }).reduce(function (a, b) {
        return a + b;
      }, 0);
    }
  }]);
  return BlockSet;
}();
exports.BlockSet = BlockSet;
var BaseBlock = /*#__PURE__*/function () {
  /**
   * a block that should be shown as filled with data
   */
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  function BaseBlock(data) {
    _classCallCheck(this, BaseBlock);
    this.widthPx = 0;
    Object.assign(this, data);
    this.assemblyName = data.assemblyName;
    this.refName = data.refName;
    this.start = data.start;
    this.end = data.end;
    this.key = data.key;
    this.offsetPx = data.offsetPx;
  }
  /**
   * rename the reference sequence of this block and return a new one
   *
   * @param refName -
   * @returns either a new block with a renamed reference sequence,
   * or the same block, if the ref name is not actually different
   */
  _createClass(BaseBlock, [{
    key: "renameReference",
    value: function renameReference(refName) {
      if (this.refName && refName !== this.refName) {
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        return new this.constructor(_objectSpread({}, this, {
          refName: refName
        }));
      }
      return this;
    }
  }, {
    key: "toRegion",
    value: function toRegion() {
      return {
        refName: this.refName,
        start: this.start,
        end: this.end,
        assemblyName: this.assemblyName,
        reversed: this.reversed
      };
    }
  }]);
  return BaseBlock;
}();
exports.BaseBlock = BaseBlock;
var ContentBlock = /*#__PURE__*/function (_BaseBlock) {
  _inherits(ContentBlock, _BaseBlock);
  function ContentBlock() {
    _classCallCheck(this, ContentBlock);
    return _possibleConstructorReturn(this, _getPrototypeOf(ContentBlock).apply(this, arguments));
  }
  return ContentBlock;
}(BaseBlock);
exports.ContentBlock = ContentBlock;
/**
 * marker block representing one or more blocks that are
 * too small to be shown at the current zoom level
 */
var ElidedBlock = /*#__PURE__*/function (_BaseBlock2) {
  _inherits(ElidedBlock, _BaseBlock2);
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  function ElidedBlock(data) {
    var _this;
    _classCallCheck(this, ElidedBlock);
    _this = _possibleConstructorReturn(this, _getPrototypeOf(ElidedBlock).call(this, data));
    _this.elidedBlockCount = 0;
    _this.widthPx = data.widthPx;
    return _this;
  }
  _createClass(ElidedBlock, [{
    key: "push",
    value: function push(otherBlock) {
      this.elidedBlockCount += 1;
      if (otherBlock) {
        this.refName = '';
        this.start = 0;
        this.end = 0;
        this.widthPx += otherBlock.widthPx;
      }
    }
  }]);
  return ElidedBlock;
}(BaseBlock);
exports.ElidedBlock = ElidedBlock;
/**
 * marker block that sits between two different displayed regions
 * and provides a thick border between them
 */
var InterRegionPaddingBlock = /*#__PURE__*/function (_BaseBlock3) {
  _inherits(InterRegionPaddingBlock, _BaseBlock3);
  function InterRegionPaddingBlock() {
    _classCallCheck(this, InterRegionPaddingBlock);
    return _possibleConstructorReturn(this, _getPrototypeOf(InterRegionPaddingBlock).apply(this, arguments));
  }
  return InterRegionPaddingBlock;
}(BaseBlock);
exports.InterRegionPaddingBlock = InterRegionPaddingBlock;